import { getPassRateColor } from "@repo/app-types/constants/passRate";
import type { Size } from "@repo/ui/helpers/helpers";
import { getPillColor } from "@repo/ui/Pills/pill";
import type { FC, ReactNode } from "react";
import { PercentagePill } from "./percentagePill.js";

export interface GradingPassRatePillProps {
  size: Size;
  /**
   * The 0-1 pass rate. `undefined` renders as a muted `--` (absent number);
   * `null` renders as an "N/A" pill (metric inapplicable).
   */
  passRate: number | null | undefined;
  isLoading?: boolean;
  onClick?: () => void;
  /** See `PercentagePill`. */
  sizedToMax?: boolean;
  /** See `PercentagePill`. */
  childrenForSize?: ReactNode;
}

export const GradingPassRatePill: FC<GradingPassRatePillProps> = (props) => (
  <PercentagePill
    size={props.size}
    value={props.passRate}
    isLoading={props.isLoading}
    computeColor={computePassRatePillColor}
    onClick={props.onClick}
    sizedToMax={props.sizedToMax}
    childrenForSize={props.childrenForSize}
  />
);

export function computePassRatePillColor(passRate: number) {
  const passRateColor = getPassRateColor(passRate);
  return getPillColor(passRateColor);
}
